export class HotSpotTranslation {
    id: number;
    hotspotId: number;
    language: any;
    name: string;

    constructor(id: number, hotspotId: number, language: any) {
        this.id = id;
        this.hotspotId = hotspotId;
        this.language = language;
    }
}

export class HotSpot {
    componentID: number;
    hotSpot: any;
    hotSpotType: 'NAVIGATION' | 'INFO' | 'VIDEO' | 'IMAGE' | 'SOUND';
    id: number
    panoramaComponent: 'MONUMENT' | 'SITE' | 'PANORAMA';
    panoramaHotspotsTranslationList: HotSpotTranslation[] = [];
    panoramaImageId: number;

    constructor(private languages?: any) {
        this.hotSpot = {hot_x: -1000, hot_y: -1000, hot_z: -1000, hot_size: 54, rotation: "left"};
        languages.forEach((language) => {
            let translation = new HotSpotTranslation(null, null, language);
            translation.name = 'New Hot spot';
            this.panoramaHotspotsTranslationList.push(translation);
        })
        this.id = Date.now();
    }


}